module.exports = __webpack_public_path__ + "img/logo.7bfe0296.png";